class IPage {
  /** current */
  current = undefined;

  /** hitCount */
  hitCount = false;

  /** pages */
  pages = undefined;

  /** records */
  records = [];

  /** searchCount */
  searchCount = false;

  /** size */
  size = undefined;

  /** total */
  total = undefined;
}

class ResponseDto {
  /** code */
  code = "";

  /** data */
  data = new IPage();

  /** failed */
  failed = false;

  /** msg */
  msg = "";

  /** success */
  success = false;

  /** traceId */
  traceId = "";
}

class SystemOrderDetailResponseDto {
  /** 手工单关联订单 */
  associated = "";

  /** 关联子订单 */
  associatedOrder = [];

  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 创建人 */
  createBy = "";

  /** 订单来源类型 1.线下销售订单，2.线下销售订单 3.外包系统订单 4.wfs订单 5.京配订单 6.京东自营订单 */
  orderType = undefined;

  /** 地址1 */
  shippingAddress1 = "";

  /** 地址2 */
  shippingAddress2 = "";

  /** 城市 */
  shippingCity = "";

  /** 国家 */
  shippingCountry = "";

  /** 国家简称 */
  shippingCountryCode = "";

  /** 邮箱 */
  shippingEmail = "";

  /** 收件人 */
  shippingName = "";

  /** 电话 */
  shippingPhone = "";

  /** 邮编 */
  shippingPostCode = "";

  /** 州 */
  shippingStateOrProvince = "";

  /** 州简称 */
  shippingStateOrProvinceCode = "";

  /** 售后状态 */
  soAfterSaleStatus = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 订单编号 */
  soOrderNo = "";

  /** 订单状态 */
  soOrderStatus = undefined;

  /** 付款状态 */
  soPayStatus = undefined;

  /** 平台备注 */
  soRemark = "";

  /** 子订单类型 1维修,2换货,3其他  */
  soSonStatus = undefined;

  /** 订单类型 */
  soType = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 折扣 */
  spDiscount = undefined;

  /** 店铺编码 */
  spMarketCode = "";

  /** 店铺 */
  spMarketName = "";

  /** 平台单号 */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 实收金额 */
  spPayAmount = undefined;

  /** 平台 */
  spPlatform = "";

  /** 退款金额 */
  spRefundAmount = undefined;

  /** 系统备注 */
  spRemark = "";

  /** 订单金额 */
  spSalesPrice = undefined;

  /** 平台税费 */
  spShipping = undefined;

  /** 支付金额 */
  spTradingPrice = undefined;

  /** 交易ID */
  transactionId = "";
}

class SystemOrderItemDetailResponseDto {
  /** 图片 */
  image = "";

  /** 商品支付价格 */
  itemPayPrice = undefined;

  /** 售价 */
  itemPrice = undefined;

  /** 商品交易价格 */
  itemTradingPrice = undefined;

  /** 数量 */
  qty = undefined;

  /** SKU */
  sku = "";

  /** 商品名称 */
  skuName = "";

  /** 币种 */
  spCurrency = "";

  /** 平台订单item Id */
  spItemNo = "";

  /** 平台商品Id */
  spProductId = "";

  /** 交易号 */
  transactionId = "";
}

class SystemOrderPackageDeliveryInformationResponseDto {
  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /**  门牌号 */
  houseNumber = "";

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 收件人地址1 */
  opShippingAddress1 = "";

  /** 收件人地址2 */
  opShippingAddress2 = "";

  /** 收件人城市 */
  opShippingCity = "";

  /** 收件人所在国家 */
  opShippingCountry = "";

  /** 收件人所在国家编码 */
  opShippingCountryCode = "";

  /** 收件人邮箱 */
  opShippingEmail = "";

  /** 收件人名字 */
  opShippingName = "";

  /** 收件人电话 */
  opShippingPhone = "";

  /** 收件人邮编 */
  opShippingPostCode = "";

  /** 收件人州或省 */
  opShippingStateOrProvince = "";

  /** 收件人州或省编码 */
  opShippingStateOrProvinceCode = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

class SystemOrderPackageItemResponseDto {
  /** 包裹item编号 */
  pioItemNo = "";

  /** 包裹单item类型 */
  pioType = undefined;

  /** 数量 */
  qty = undefined;

  /** sku */
  sku = "";

  /** 系统订单商品号 */
  soItemNo = "";

  /** 平台订单商品号 */
  spItemNo = "";

  /** 交易号 */
  transactionId = "";
}

class SystemOrderPackageResponseDto {
  /** 是否可以直接提交订单 */
  checkSubmit = false;

  /** 物流渠道 */
  logisticsChannel = "";

  /** 发货时间 */
  logisticsDeliveryTime = "";

  /** 发货仓库 */
  logisticsDeliveryWarehouse = "";

  /** 推送到PayPal状态 1未推送 2 推送成功 3 推送失败 */
  logisticsPaypalTracking = undefined;

  /** 物流单号 */
  logisticsTrackingNo = "";

  /** 包裹单 */
  opNo = "";

  /** 包裹状态 */
  opStatus = undefined;

  /** 包裹重量(g) */
  opWeight = "";

  /** sku详情 */
  orderPackageItemResponseDtos = [];

  /** 退件原因详情 */
  returnExplain = "";

  /** 退件原因 */
  returnReason = "";

  /** 退件时间 */
  returnTime = "";

  /** 系统订单号 */
  soOrderNo = "";
}

class SystemOrderResponseDto {
  /** 买家ID/编号 */
  buyerCode = "";

  /** 买家邮箱 */
  buyerEmail = "";

  /** 买家留言 */
  buyerMessage = "";

  /** 买家指定物流 */
  buyerSpecifyLogistics = "";

  /** 创建人 */
  createBy = "";

  /** 创建时间 */
  createTime = "";

  /** 客户id */
  customerId = "";

  /** 客户信息id,主要用于线下销售订单 */
  customerName = "";

  /** 删除标识 0:否 */
  deleted = undefined;

  /** 派送方式,0:非自提，1:买家自提 */
  deliveryMethod = undefined;

  /** 折扣码 */
  discountCode = "";

  /** 仓库首次完成拣货时间 */
  finishPickingTime = "";

  /** 仓库首次实际出货时间 */
  firstActualDeliveryTime = "";

  /** 仓库首次拣货时间 */
  firstPickUpTime = "";

  /** 0:不是历史订单 1历史订单 */
  historyOrder = false;

  /** id */
  id = undefined;

  /** 乐观锁 */
  lockVersion = undefined;

  /** 物流运费 */
  logisticsShipping = undefined;

  /** 发运方式 1:平台配送 2:卖家自配送 */
  orderShipmentMethod = undefined;

  /** 平台大类 1:平台订单,2:企业订单 */
  orderType = undefined;

  /** 付款方式 */
  payMethod = "";

  /** 收件人地址1 */
  shippingAddress1 = "";

  /** 收件人地址2 */
  shippingAddress2 = "";

  /** 收件人城市 */
  shippingCity = "";

  /** 收件人所在国家 */
  shippingCountry = "";

  /** 收件人所在国家编码 */
  shippingCountryCode = "";

  /** 收件人邮箱 */
  shippingEmail = "";

  /** 收件人名字 */
  shippingName = "";

  /** 收件人电话 */
  shippingPhone = "";

  /** 收件人邮编 */
  shippingPostCode = "";

  /** 收件人州或省 */
  shippingStateOrProvince = "";

  /** 收件人州或省编码 */
  shippingStateOrProvinceCode = "";

  /** 收件人纳税号 */
  shippingTaxid = "";

  /** 系统订单售后状态 1正常 2退款 3部分退款 4退货 5部分退货 */
  soAfterSaleStatus = undefined;

  /** 系统订单生成方式 1:平台传输生成 2:系统内创建 */
  soBuildAction = undefined;

  /** 系统订单取消原因 */
  soCancelReason = "";

  /** 系统订单异常原因 */
  soErrorCause = "";

  /** 系统订单拦截原因 */
  soInterceptReson = "";

  /** 系统订单号 */
  soOrderNo = "";

  /** 系统订单付款状态 0未付款 1已付款 2部分退款 3已退款 */
  soPayStatus = undefined;

  /** 系统订单退款金额 */
  soRefundAmount = undefined;

  /** 系统订单备注 */
  soRemark = "";

  /** 系统订单状态:0未付款 1待审核  2待发货 3缺货 4物流问题 5发货问题 6部分发货 7已完成 8已取消 9风险订单 10已拦截  11异常确认 12派送失败 13已签收 */
  soStatus = undefined;

  /** 贸易主体编码 */
  soTradeCompanyCode = "";

  /** 贸易主体名称 */
  soTradeCompanyName = "";

  /** 系统订单类型 1正常 2补发 3重发 4测评 5改发 6换货 7维修 */
  soType = undefined;

  /** 平台订单佣金 */
  spCommission = undefined;

  /** 平台订单币种 */
  spCurrency = "";

  /** 平台订单优惠额 */
  spDiscount = undefined;

  /** 平台订单店铺 */
  spMarketCode = "";

  /** 平台订单店铺名称 */
  spMarketName = "";

  /** 平台订单id（平台生成） */
  spOrderId = "";

  /** 平台订单号（客服填写） */
  spOrderNo = "";

  /** 平台订单下单时间 */
  spOrderTime = "";

  /** 平台订单更新时间 */
  spOrderUpdateTime = "";

  /** 平台订单实收款 */
  spPayAmount = undefined;

  /** 平台订单支付时间 */
  spPaymentDate = "";

  /** 平台订单来源平台 */
  spPlatform = "";

  /** 平台订单退款金额 */
  spRefundAmount = undefined;

  /** 平台订单备注 */
  spRemark = "";

  /** 平台订单销售价 */
  spSalesPrice = undefined;

  /** 平台订单运费 */
  spShipping = undefined;

  /** 平台订单发货状态 1未发货 2部分发货 3已发货 */
  spShippingStatus = undefined;

  /** 平台订单状态 */
  spStatus = "";

  /** 平台订单税费 */
  spTaxes = undefined;

  /** 平台订单交易价 */
  spTradingPrice = undefined;

  /** 交易ID */
  transactionId = "";

  /** 更新人 */
  updateBy = "";

  /** 更新时间 */
  updateTime = "";
}

export const oms = {
  IPage,
  ResponseDto,
  SystemOrderDetailResponseDto,
  SystemOrderItemDetailResponseDto,
  SystemOrderPackageDeliveryInformationResponseDto,
  SystemOrderPackageItemResponseDto,
  SystemOrderPackageResponseDto,
  SystemOrderResponseDto,
};
